module.exports = __webpack_public_path__ + "img/show_tc_text_12.ce777156.png";